import { render } from "./RolesEditorProjectsEducation.vue?vue&type=template&id=11342da6"
import script from "./RolesEditorProjectsEducation.vue?vue&type=script&lang=js"
export * from "./RolesEditorProjectsEducation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__